
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import regular from "@/common/regular";
import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import infoTitle from "@/components/info-title/info-title.vue";
import { saveSmsCombo } from "@/api/api-basic-sms";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-upload-image": uploadImage,
    "pi-show-img": showImg,
    "pi-info-title": infoTitle
  }
})
export default class MessageAddMadel extends Vue {
  private modalShow = false;
  private loading = false;
  private modalTitle = i18n.t("messagePrice.add");
  private FormData: objAny = {};

  private ruleInline: objAny = {
    number: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur",
        max: 20000,
        name: i18n.t("messagePrice.number")
      }
    ],
    qrCodeFilePkId: [
      {
        required: true,
        message: i18n.t("messagePrice.qrCodeFilePkIdPl"),
        trigger: "change"
      }
    ],
    price: [
      {
        required: true,
        validator: regular.money,
        trigger: "blur"
      }
    ],
    contactPhone: [
      {
        required: true,
        validator: regular.phone,
        trigger: "blur"
      }
    ]
  };
  private formItem: objAny = {
    comboPkId: "",
    contactPhone: "",
    number: "",
    price: "",
    qrCodeFilePkId: "",
    status: "1",
    remark: ""
  };
  private oprSystemLogoFilePath = "";

  public open(item: objAny, type?: string) {
    this.$nextTick(() => {
      this.handleReset();
    });
    if (item.comboPkId) {
      this.modalTitle = i18n.t("messagePrice.updata");
      this.formItem.comboPkId = item.comboPkId;
      this.formItem.contactPhone = item.contactPhone;
      this.formItem.number = item.number;
      this.formItem.price = item.price;
      this.formItem.qrCodeFilePkId = item.qrCodeFilePkId;
      this.oprSystemLogoFilePath = item.qrCodeFileUrl;

      this.formItem.remark = item.remark;
      if (type == "status") {
        this.formItem.status = item.status == "0" ? "1" : "0";
        this.submitData();
      } else {
        this.formItem.status = item.status;
        this.modalShow = true;
      }
    } else {
      this.oprSystemLogoFilePath = "";
      this.modalTitle = i18n.t("messagePrice.add");
      this.modalShow = true;
      this.formItem.comboPkId = "";
      this.formItem.contactPhone = "";
      this.formItem.number = "";
      this.formItem.price = "";
      this.formItem.qrCodeFilePkId = "";
      this.formItem.remark = "";
      this.formItem.status = "1";
    }
  }

  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formItem;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    const ret = await saveSmsCombo(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public uploadImg(data: objAny): void {
    this.oprSystemLogoFilePath = data.filePath;
    this.formItem.qrCodeFilePkId = data.attachmentRecordPkId; //data.thumbnailFilePath;
  }
}
